import React from 'react';
import PropTypes from 'prop-types';

function BillingShareButton({ onGetLink }) {
  return (
    <div
      className="d-inline ml-2 mb-3"
    >
      <button
        type="button"
        onClick={onGetLink}
        className="btn btn-secondary"
        aria-label="share"
      >
        Share
      </button>
    </div>
  );
}

BillingShareButton.propTypes = {
  onGetLink: PropTypes.func.isRequired,
};

export default BillingShareButton;
